import React, {useState, useEffect, useMemo, useRef} from 'react';
import Box from 'react-styled-box';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, change, reduxForm, formValueSelector, destroy, SubmissionError } from 'redux-form';
import _pick from 'lodash/pick';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _size from 'lodash/size';
import store from 'store';
import usePrevious from 'UsePrevious.js';
import useToggle from 'UseToggle.js'
import { fetchNewCustomerDataByMyId } from 'customerDataByMyIdActions.js';
import { logInUser, registerUser, registerUserByMyId, preregisterUser, verificationCode, smsCodeVerifyWithAttempts } from 'authActions.js';
import { loadPublicRegConsents, getMyIdStatus } from 'customerActions.js';
import { addIncomeAccessData, setIncomeAccessIframe } from 'integrationActions.js';
import  {getFavouriteLeagues } from 'favouritesActions.js';
import { fetchPromoCodeSetting } from 'topMenuActions.js';
import {translation, triggerNativeEvent, pushCustomEventToGoogleAnalytics, redirect} from 'utilsHelper.js';
import { getPromoCookie, setGoogleDataLayerCookie, getBtagCookie, getMyAffiliateTokenCookie } from 'cookiesHelper.js';
import { prepareUserData, renderField, prepareRegistrationPayload } from 'registerHelper.js'
import {substractYears, formatDate} from 'datesHelper.js';
import {getDateOfBirthFromPesel} from 'validateHelper.js';
import { STEPS_CONFIG, HEADERS } from 'registerConsts.js'
import ModalOpacity from 'ModalOpacity.js';
import RegisterWizardFormStep0 from 'RegisterWizardFormStep0.js';
import RegisterWizardFormStep1 from 'RegisterWizardFormStep1.js';
import RegisterWizardFormStep2 from 'RegisterWizardFormStep2.js';
import RegisterFormByMyIdStep1 from 'RegisterFormByMyIdStep1.js';
import RegisterFormByMyIdStep2 from 'RegisterFormByMyIdStep2.js';
import RegisterFormByMyIdStep3 from 'RegisterFormByMyIdStep3.js';
import CmsPage from 'CmsPage.js';
import BellIcon from 'bell-icon.svg';
import S from 'StyledRegisterWizardForm.js';

const asyncValidate = async (values, dispatch, props, field) => {
    if (field === 'smsCode' && values.smsCode) {
        try {
            await dispatch(smsCodeVerifyWithAttempts('smsCode', values.smsCode, values.mobile));
        } catch (err) {
            throw { smsCode: [translation('account_registerForm_verificationCode_wrongSMSCode')] };
        }
    }
};

const RegisterWizardForm = (props) => {

    const {
        smsVerificationCode,
        personalIdentifier,
        isPromoCodeVisible,
        loadPublicRegConsents,
        logInUser,
        registerUser,
        preregisterUser,
        verificationCode,
        fetchPromoCodeSetting,
        getFavouriteLeagues,
        isMyIdActive,
        getMyIdStatus,
        fetchNewCustomerDataByMyId, 
        submitting,
        handleSubmit,
        userData,
        mobile,
    } = props;

    const isBankPath = window.location.pathname.includes('registerByMyId');
    const navigation = typeof window !== 'undefined' && performance.getEntriesByType('navigation')[0];
    const isReload = isBankPath && navigation && navigation.type === 'reload';

    const [affiliateParam, setAffiliateParam] = useState();
    const [registrationMethod, setRegistrationMethod] = useState(null);
    const [step, setNextStep] = useState(0);
    const [registrationConsents, setRegConsents] = useState([]);
    const [resendCountdown, setResendCountdown] = useState(0);
    const [pendingValues, setPendingValues] = useState(null);
    const [wasMarketingModalShown, setWasMarketingModalShown] = useState(false);
    const [showConfirmationModal, toggleConfirmationModal] = useToggle(false);
    const [showMarketingConsentModal, toggleMarketingConsentModal] = useToggle(false);
    const [showSmsModal, toggleSmsModal] = useToggle(false);
    const prevStep = usePrevious(step);
    const prevFirstStepValues = usePrevious({smsVerificationCode, personalIdentifier});
    const incomeAccessIframeRef = useRef();
    const {dispatch} = store;
    const customerRegStepTwoTag = 'CUSTOMER_REGISTRATION_STEP_2';

    const toggleRegistrationTag = (addTag, tagName) => {
        const loc = window.location;
        const baseUrl = loc.origin + '/';

        if (addTag) {
            const newUrl = `${baseUrl}?rejestracja#${tagName}`;
            history.replaceState({}, document.title, newUrl);
        } else {
            if ('pushState' in history) {
                history.replaceState({}, document.title, baseUrl);
            }
        }
    };

    useEffect(() => {
        let timer;
        if (resendCountdown > 0) {
            timer = setInterval(() => {
                setResendCountdown(prev => prev - 1);
            }, 1000);
        }
        return () => clearInterval(timer);
    }, [resendCountdown]);

    useEffect(() => {
        if (isReload) {
            redirect('/'); 
        }
    }, [isReload]);

    useEffect(() => {
        if (isReload) return;

        destroy('registerWizardForm');
        getMyIdStatus();
        fetchPromoCodeSetting();

        const btagParam = getBtagCookie();
        let firstPartBtagParam = btagParam?.split("b")[0]?.replace('_', '') || 'default';
        setAffiliateParam(firstPartBtagParam);

        getPublicRegConsents().then(data => setRegConsents(data)); 

        if (!isBankPath) {
            toggleRegistrationTag(true, 'registerStart');
            return () => toggleRegistrationTag(false, 'registerStart');
        }
    }, [isReload]);

    useEffect(() => {
        if (isBankPath && !isReload) {
            const params = new URLSearchParams(window.location.search);
            const myIdToken = params.get('myIdToken');
            const pathToken = window.location.pathname.split('registerByMyId/')[1];
            const finalToken = myIdToken || pathToken;

            if (finalToken) {
                setRegistrationMethod('bank');
                setNextStep(1);
                if (fetchNewCustomerDataByMyId) fetchNewCustomerDataByMyId(finalToken);
            }
        }
    }, [isReload]);

    useEffect(() => {
        if (step === 0) {
            setWasMarketingModalShown(false);
        }
    }, [step]);

    useEffect(() => {
        if (step == 1 && step != prevStep) {
            setTimeout(() => dispatch(change('registerWizardForm', 'password', '')), 500);
        } else if (step == 2 && step != prevStep) {
            if (prevFirstStepValues.personalIdentifier){
                triggerNativeEvent('[name="personalIdentifier"]', 'blur');
            }
            if (prevFirstStepValues.smsVerificationCode){
                triggerNativeEvent('[name="verificationCode"]', 'blur');
            }

        }

    }, [step]);

    const memoizedInitialValues = useMemo(() => {
        const base = userData || {};
            return {
                country: base.country || 'PL',
                ...base,
                bonus: true
            };
    }, [userData]);

    const startCountdown = () => setResendCountdown(60);

    const handleResendSms = async () => {
        if (resendCountdown === 0 && mobile) {
            try {
                await verificationCode({ mobile });
                startCountdown();
            } catch (error) {
                console.error("Błąd ponownej wysyłki:", error);
            }
        }
    };

    const handleMethodSelect = (method) => {
        setRegistrationMethod(method);
        setNextStep(1);
    };

    const handleBankRedirect = () => {
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        
        const apiBase = isLocalhost 
            ? 'https://test.fuksiarz.pl' 
            : window.location.origin;

        const returnUrl = encodeURIComponent(`${window.location.origin}/registerByMyId`);
        const initializeUrl = `${apiBase}/rest/customer/identity-resolver/my-id/initialize?returnUrl=${returnUrl}`;
        window.location.href = initializeUrl;
    };

    const getPublicRegConsents = async() => {
        try {
            const data = await loadPublicRegConsents(customerRegStepTwoTag);
            return data.CUSTOMER_REGISTRATION_STEP_2 || [];
        } catch (error) {
            throw error;
        }
    };

    const onStep3Submit = async (values) => {
        setPendingValues(values);

        if (values.marketingConsent === true || wasMarketingModalShown) {
            processStep3Flow(values, values.marketingConsent || false);
        } else {
            setWasMarketingModalShown(true);
            toggleMarketingConsentModal();
        }
    };

    const handleFinalRegistration = async (values) => {
        try {
            const myAffiliateToken = getMyAffiliateTokenCookie();
            const btag = getBtagCookie();
            const clickId = btag;
            const promoCode = getPromoCookie() || app.config.defaultPromoCode;

            const payload = prepareRegistrationPayload(values, myAffiliateToken, btag, clickId, promoCode);

            const customerId = await dispatch(registerUserByMyId(payload));
            setIncomeAccessIframe(customerId, incomeAccessIframeRef);
            if (customerId) {
                setGoogleDataLayerCookie(customerId);
                pushCustomEventToGoogleAnalytics({
                    'event': 'registerEnd',
                    'category': 'conversion',
                    'userId': customerId,
                })
            }

            toggleSmsModal(false);

            if (!values.emailActivation) {
                await loginOnSubmit({'login': values.email, 'password': values.password});
                toggleRegistrationTag(true, 'registerEnd');
            } else {
                toggleConfirmationModal();
                toggleRegistrationTag(true, 'registerEnd');
            }            
        } catch (error) {
            toggleSmsModal(false);
            throw new SubmissionError({_error: error});
        }
    };

    const registerFirstStep = () => {
        const values = store.getState().form.registerWizardForm.values;
        const pickedValues = ['email', 'marketingConsent', 'mobile'];
        const registerData = _pick(values, pickedValues);
        const marketingConsentInner = _get(registerData, ['marketingConsent']);

            try {

                if (marketingConsentInner == true) {
                    preregisterUser(registerData);
                }

                const mobile = _pick(values, ['mobile']);
                const previousMobile = _pick(values, ['previousMobileNumber']);
                if(mobile.mobile != previousMobile.previousMobileNumber){
                    dispatch(change("registerWizardForm","previousMobileNumber", mobile.mobile));
                    verificationCode(mobile);
                }

                setNextStep((prevStep) => prevStep + 1);

            } catch (error) {
                throw new SubmissionError({_error: error});
            } 
        
    };

   const registerOnSubmit = async (postData) => {
        try {
            const newUser = await registerUser(postData);
            return newUser;
        } catch (error) {
            throw error;
        }
    };

    const loginOnSubmit = async (postData) => {
        try {
            const user = await logInUser(postData);
            const {userId} = user;
            if (userId) {
                setGoogleDataLayerCookie(userId);
            }
            getFavouriteLeagues();
            app.partial.EventListCountryList.showFavouritesOnSubmit();
            return user;
        } catch (error) {
            throw error;
        }
    };

    const registerSecondStep = async (values) => {
        try {

            let pickedValues = [
                'firstName',
                'lastName',
                'nationality',
                'password',
                'email',
                'mobile',
                'verificationCode'
            ];

            const nationalityPL = _get(values, ['nationality']);
            if (nationalityPL == 'PL') {
                pickedValues = [...pickedValues, 'personalIdentifier'];
            } else {
                pickedValues = [...pickedValues, 'postalCode', 'address', 'dateOfBirth'];
            }

            const fieldPromoCode = _get(values, ['promoCode']);
            // Jeżeli jest widoczny i uzupełniony ręcznie lub pobrany z cookies, wczytaj normalnie z values
            if (fieldPromoCode){
                pickedValues = [...pickedValues, 'promoCode'];
            }

            let registerData = _pick(values, pickedValues);
            if ('personalIdentifier' in registerData) {
                registerData['personalIdentificationNumber'] = registerData['personalIdentifier'];
                const dateOfBirthFromPesel = getDateOfBirthFromPesel(registerData['personalIdentificationNumber']);
                registerData['dateOfBirth'] = formatDate(dateOfBirthFromPesel, 'yyyy-MM-dd');
                delete registerData['personalIdentifier'];
            }

            const emailVerification = _get(values, ['emailVerification']);
            if(emailVerification){
                registerData['verificationCode'] = null;
            }

            // opis działania w tasku 80019
            const promoCode = getPromoCookie();
            if(!isPromoCodeVisible && promoCode){
                registerData['promoCode'] = promoCode;
            } else if (!promoCode && !fieldPromoCode) {
                registerData['promoCode'] = app.config.defaultPromoCode;
            }

            registerData = addIncomeAccessData(registerData);
            
            const btag = registerData.affiliateId;
            if (btag){
                registerData['btag'] = btag;
                registerData = _.omit(registerData, 'affiliateId');
            }
            
            registerData.countryCode = process.env.MAIN_COUNTRY_CODE;
            registerData.currencyCode = process.env.MAIN_CURRENCY_CODE;

            const offerContainers = [];
            for(let i in registrationConsents){
              offerContainers.push({
                "container": "OFFERS", "accepted": _get(values, ['isBonus']), "definitionId": registrationConsents[i].definitionId
              })
            }

            registerData['consents'] = [
                { "container": "LOTTERY_PARTICIPATION", "accepted": false },
                { "container": "REGULATIONS", "accepted": true },
                ...offerContainers
            ];
            //temporary solution for my affiliate token
            const marketingConsent = _get(values, ['marketingConsent']);
            if (marketingConsent) {
                registerData['consents'].push(
                    { "container": "EMAIL", "accepted": marketingConsent },
                    { "container": "SMS", "accepted": marketingConsent }
                );
            } else if (emailVerification) {
                registerData['consents'].push(
                    { "container": "EMAIL", "accepted": true },
                    { "container": "SMS", "accepted": false }
                );
            } else {
                registerData['consents'].push(
                    { "container": "EMAIL", "accepted": false },
                    { "container": "SMS", "accepted": true }
                );
            };

            const myAffiliateToken = Cookies.get('myAffiliateToken');
            if (myAffiliateToken) registerData['affiliateToken'] = myAffiliateToken;

            const customerId = await registerOnSubmit(registerData);
            setIncomeAccessIframe(customerId, incomeAccessIframeRef);
            if (customerId) {
                setGoogleDataLayerCookie(customerId);
                pushCustomEventToGoogleAnalytics({
                    'event': 'registerEnd',
                    'category': 'conversion',
                    'userId': customerId,
                })
            }
            
            if(!emailVerification){
                const loginData = _pick(values, ['password']);
                loginData['login'] = _get(_pick(values, ['email']), ['email']);
                await loginOnSubmit(loginData);
                toggleRegistrationTag(true, 'registerEnd');
            }else{
                toggleConfirmationModal();
                toggleRegistrationTag(true, 'registerEnd');
            }

        } catch (error) {
            throw new SubmissionError({_error: error});
        }
    };

    const secondStepInitialValues = useMemo(() => {
        const date = substractYears(new Date(), 18);
        
        let data = {
            isBonus: true,
            dayOfBirth: date.getDate(),
            monthOfBirth: date.getMonth(),
            yearOfBirth: date.getFullYear(),
            nationality: process.env.MAIN_COUNTRY_CODE
        };

        const promo = getPromoCookie();
        promo?  data['promoCode'] = promo :  data['promoCode'] = app.config.defaultPromoCode
        return data;
    }, []);

    const handleSubmitOnClick = async (values) => { // method to check if marketingConsent is true and if not modal will appear
        setPendingValues(values);

        if (values.marketingConsent === true || wasMarketingModalShown) {
            registerFirstStep();
        } else {
            setWasMarketingModalShown(true);
            toggleMarketingConsentModal(); 
        }
    }

    const handleButtonClick = (isAccepted = false) => {
        dispatch(change("registerWizardForm", "marketingConsent", isAccepted));

        toggleMarketingConsentModal(); 

        const finalValues = { 
            ...pendingValues, 
            marketingConsent: isAccepted, 
        };

        if (registrationMethod === 'bank' && step === 3) {
            processStep3Flow(finalValues, isAccepted);
        } else {
            registerFirstStep();
        }
    };

    const processStep3Flow = async (values, marketingAccepted) => {
        if (marketingAccepted) {
            const preregisterPayload = {
                email: values.email,
                marketingConsent: values.marketingConsent,
                mobile: values.mobile
            };

            try {
                await preregisterUser(preregisterPayload);
            } catch (e) { console.error(e); }
        }

        if (!values.emailActivation) {
            try {
                if(values.mobile) {
                    verificationCode({ 'mobile': values.mobile });
                    startCountdown();
                }
                toggleSmsModal(true);
            } catch (error) { console.error(error); }
        } else {
            handleFinalRegistration(values);
        }
    };

    const onConfirmationModalClose = () => {
        toggleConfirmationModal();
        redirect('/');
    }

    const isCountryFromBank = !!(userData && userData.country);

    return (
            <S.RegisterWizardForm>
                <S.LogoWrapper>
                    <S.Link href={`/`}>
                        <S.Logo src='/images/svg/logo-desktop.svg' alt='Najlepszy legalny polski bukmacher Fuksiarz.pl - obstawiaj mecze i sprawdź wysokie kursy'/>
                    </S.Link>
                </S.LogoWrapper>
                <S.LoginButton onClick={()=>redirect('/login')} data-translation='registerForm_loginButton'>{translation('registerForm_loginButton')}</S.LoginButton>
                <S.BannerWrapper>
                    {affiliateParam && <CmsPage name={`affiliate-${affiliateParam}`} alternativeContent="affiliate-default" isPlaces={true}/> }
                </S.BannerWrapper>

                {step > 0 && registrationMethod && HEADERS[registrationMethod][step - 1] && (
                    <S.Title>
                        {translation(HEADERS[registrationMethod][step - 1].translation_key)}
                    </S.Title>
                )}

                {step > 0 && registrationMethod && (
                    <S.Stepper stepsCount={STEPS_CONFIG[registrationMethod].length}>
                        {STEPS_CONFIG[registrationMethod].map((config, index) => {
                            const stepNum = index + 1;
                            const isCompletedOrActive = step >= stepNum;
                            const isCurrent = step === stepNum;
                            const canGoBack = step > stepNum;

                            return (
                                <S.StepWrapper key={index}>
                                    <S.Step 
                                        hasPointer={canGoBack} 
                                        onClick={() => canGoBack && setNextStep(stepNum)} 
                                    >
                                        <S.StepCircle isActive={isCompletedOrActive}>
                                            {stepNum}
                                        </S.StepCircle>
                                        <S.StepLabel isActive={isCompletedOrActive} isCurrent={isCurrent}>
                                            {translation(config.label)}
                                        </S.StepLabel>
                                    </S.Step>
                                </S.StepWrapper>
                            );
                        })}
                    </S.Stepper>
                )}

                {/* MARKETING CONSENT ACCEPTATION MODAL */}
                <ModalOpacity isOpen={showMarketingConsentModal}
                            toggleOpen={toggleMarketingConsentModal}
                            showHeader={false}
                            showCloseIcon={false}
                            padding={0}
                            preventCloseOnOverlay={true}
                            >
                    <S.Dialog>
                        <Box flexDirection="column">

                            <Box justifyContent="center">
                                <S.BellIcon dangerouslySetInnerHTML={{__html: BellIcon}}></S.BellIcon>
                            </Box>

                            <Box margin="20px 0 0" alignSelf="center">
                                <S.DialogText data-translation="registerForm_marketingConsent_additionalText">{translation('registerForm_marketingConsent_additionalText')}</S.DialogText>
                            </Box>

                            <Box justifyContent="space-between" margin="20px 0 0">
                                <S.DialogBtnOk onClick={()=>{handleButtonClick(true)}} data-translation="registerForm_marketingConsent_buttonAccept">{translation('registerForm_marketingConsent_buttonAccept')}</S.DialogBtnOk>
                                <S.DialogBtnCancel onClick={()=>{handleButtonClick(false)}} data-translation="registerForm_marketingConsent_buttonCancel">{translation('registerForm_marketingConsent_buttonCancel')}</S.DialogBtnCancel>
                            </Box>
                        </Box>
                    </S.Dialog>
                </ModalOpacity>

                {/* SMS VERIFICATION CODE MODAL */}
                <ModalOpacity isOpen={showSmsModal} toggleOpen={toggleSmsModal} showHeader={false} padding={0} preventCloseOnOverlay={true}>
                    <S.Dialog>
                        <Box flexDirection="column" alignItems="center">
                            <S.DialogText>{translation('registerForm_smsModalHeader')}</S.DialogText>
                            <Box width="100%" margin="10px 0 20px 0">
                                <Field name="smsCode" component={renderField} S={S} label={translation('registerForm_smsCodePlaceholder')}/>
                            </Box>
                            <Box flexDirection="column" alignItems="center" margin="15px 0 0">
                                <S.ResendText>{translation('registerForm_smsModalText') }</S.ResendText>
                                {resendCountdown > 0 ? (
                                    <S.ResendCounter>
                                        {translation('registerForm_resendCodeWait')} {resendCountdown}s
                                    </S.ResendCounter>
                                ) : (
                                    <S.ResendButton onClick={handleResendSms}>
                                        {translation('registerForm_resendSmsCode')}
                                    </S.ResendButton>
                                )}
                            </Box>
                            <Box width="100%">
                                <S.SubmitBtn disabled={submitting} onClick={handleSubmit(handleFinalRegistration)}>
                                    {translation('registerForm_submit')}
                                </S.SubmitBtn>
                            </Box>
                        </Box>
                    </S.Dialog>
                </ModalOpacity>

                {/* REGISTER CONFIRMATION MODAL */}
                <ModalOpacity isOpen={showConfirmationModal}
                            toggleOpen={onConfirmationModalClose}
                            showHeader={false}
                            padding={0}
                            showCloseIcon={false}
                            >
                    <S.ConfirmationModal>
                        <S.ConfirmationMsg data-translation="account_unloggedPanel_confirmationModal">{translation('account_unloggedPanel_confirmationModal')}</S.ConfirmationMsg>
                        <S.ConfirmationCloseBtn data-translation="common_ok"
                            onClick={onConfirmationModalClose}>{translation('common_ok')}</S.ConfirmationCloseBtn>
                    </S.ConfirmationModal>


                </ModalOpacity>

                {step === 0 && !isBankPath && (
                    <RegisterWizardFormStep0 
                        onFormSelect={() => handleMethodSelect('form')} 
                        onBankSelect={handleBankRedirect}
                        isMyIdActive={isMyIdActive}
                    />
                )}

                {registrationMethod === 'bank' && (
                    <>
                        {step === 1 && <RegisterFormByMyIdStep1 onSubmit={() => setNextStep(2)} initialValues={memoizedInitialValues}/>}
                        {step === 2 && <RegisterFormByMyIdStep2 onSubmit={() => setNextStep(3)} initialValues={memoizedInitialValues} isCountryLocked={isCountryFromBank}/>}
                        {step === 3 && <RegisterFormByMyIdStep3 onSubmit={(values) => onStep3Submit(values)} initialValues={memoizedInitialValues}/>}
                    </>
                )}

                {registrationMethod === 'form' && (
                    <>
                        {step === 1 && <RegisterWizardFormStep1 onSubmit={handleSubmit(handleSubmitOnClick)}/>}
                        {step === 2 && <RegisterWizardFormStep2 initialValues={secondStepInitialValues} onSubmit={registerSecondStep} isPromoCodeVisible={isPromoCodeVisible}/>}
                    </>
                )}
                <S.HideIframe ref={incomeAccessIframeRef}></S.HideIframe>
            </S.RegisterWizardForm>
    );
};

const selector = formValueSelector('registerWizardForm');
const mapStateToProps = (state) => {
    const {TopMenu:{ isPromoCodeVisible }} = state;
    const isMyIdActive = _get(state, 'Customer.isMyIdActive', false);
    const customerDataByMyId = _get(state, 'CustomerDataByMyId.customerDataByMyId');

    const userData = prepareUserData(customerDataByMyId);

    return {
        personalIdentifier:  selector(state, 'personalIdentifier'),
        smsVerificationCode:  selector(state, 'verificationCode'),
        mobile: selector(state, 'mobile'),
        isPromoCodeVisible,
        isMyIdActive,
        customerDataByMyId,
        userData,
        // selectAll:  selector(state, 'selectAllFields')
    };
};

const mapDispatchToProps = (dispatch) => {
  const bindedActions = {
      loadPublicRegConsents,
      logInUser,
      registerUser,
      registerUserByMyId,
      preregisterUser,
      verificationCode,
      fetchPromoCodeSetting,
      getFavouriteLeagues,
      getMyIdStatus,
      fetchNewCustomerDataByMyId,
  }

  return {
      ...bindActionCreators(bindedActions, dispatch),
      dispatch
  }
}

const connectedWizard = connect(mapStateToProps, mapDispatchToProps)(RegisterWizardForm);

export default reduxForm({
    form: 'registerWizardForm',
    asyncValidate,
    asyncBlurFields: ['smsCode'],
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
    enableReinitialize: true, 
    keepDirtyOnReinitialize: true
})(connectedWizard);